function LoadingSpinner({ size = 'medium', className = '' }) {
    const sizeClass = `loading-spinner--${size}`;
    const spinnerClass = ['loading-spinner', sizeClass, className].filter(Boolean).join(' ');

    return (
        <div className={spinnerClass}>
            <div className="spinner-circle"></div>
            <div className="spinner-text">Loading...</div>
        </div>
    );
}

export default LoadingSpinner;
